module.exports = __webpack_public_path__ + "static/tech-blog-27f259c42761372814eb822bfd9c9d62.jpg";